export const postalCodesByMunicipality: Array<{
  postalCodes: Array<string>
  code: string
}> = [
  {
    postalCodes: [
      '07230',
      '07500',
      '07510',
      '07530',
      '07580',
      '07590',
      '07680'
    ],
    code: '018'
  },
  {
    postalCodes: [
      '02100',
      '02110',
      '02120',
      '02130',
      '02140',
      '02150',
      '02160',
      '02170',
      '02180',
      '02200',
      '02210',
      '02230',
      '02240',
      '02250',
      '02260',
      '02270',
      '02280',
      '02290',
      '02300',
      '02320',
      '02330',
      '02340',
      '02360',
      '02380',
      '02600',
      '02610',
      '02620',
      '02630',
      '02650',
      '02660',
      '02680',
      '02710',
      '02720',
      '02730',
      '02740',
      '02750',
      '02760',
      '02770',
      '02780',
      '02810',
      '02820',
      '02860',
      '02920',
      '02940',
      '02970',
      '02980'
    ],
    code: '049'
  },
  { postalCodes: ['10820', '10900', '10940', '10960'], code: '078' },
  {
    postalCodes: [
      '00100',
      '00120',
      '00130',
      '00140',
      '00150',
      '00160',
      '00170',
      '00180',
      '00190',
      '00200',
      '00210',
      '00220',
      '00230',
      '00240',
      '00250',
      '00260',
      '00270',
      '00280',
      '00290',
      '00300',
      '00310',
      '00320',
      '00330',
      '00340',
      '00350',
      '00360',
      '00370',
      '00380',
      '00390',
      '00400',
      '00410',
      '00420',
      '00430',
      '00440',
      '00500',
      '00510',
      '00520',
      '00530',
      '00540',
      '00550',
      '00560',
      '00570',
      '00580',
      '00590',
      '00600',
      '00610',
      '00620',
      '00630',
      '00640',
      '00650',
      '00660',
      '00670',
      '00680',
      '00690',
      '00700',
      '00710',
      '00720',
      '00730',
      '00740',
      '00750',
      '00760',
      '00770',
      '00780',
      '00790',
      '00800',
      '00810',
      '00820',
      '00830',
      '00840',
      '00850',
      '00860',
      '00870',
      '00880',
      '00890',
      '00900',
      '00910',
      '00920',
      '00930',
      '00940',
      '00950',
      '00960',
      '00970',
      '00980',
      '00990'
    ],
    code: '091'
  },
  {
    postalCodes: [
      '01200',
      '01230',
      '01260',
      '01280',
      '01300',
      '01340',
      '01350',
      '01360',
      '01370',
      '01380',
      '01390',
      '01400',
      '01420',
      '01450',
      '01480',
      '01490',
      '01510',
      '01520',
      '01530',
      '01600',
      '01610',
      '01620',
      '01630',
      '01640',
      '01650',
      '01660',
      '01670',
      '01680',
      '01690',
      '01700',
      '01710',
      '01720',
      '01730',
      '01740',
      '01750',
      '01760',
      '01770'
    ],
    code: '092'
  },
  {
    postalCodes: [
      '05440',
      '05460',
      '05470',
      '05510',
      '05620',
      '05720',
      '05800',
      '05810',
      '05820',
      '05830',
      '05840',
      '05850',
      '05860',
      '05880',
      '05900',
      '05950'
    ],
    code: '106'
  },
  {
    postalCodes: [
      '10120',
      '10140',
      '10160',
      '10210',
      '10230',
      '10250',
      '10270'
    ],
    code: '149'
  },
  {
    postalCodes: [
      '04400',
      '04410',
      '04420',
      '04430',
      '04440',
      '04460',
      '04480'
    ],
    code: '186'
  },
  { postalCodes: ['03600', '03620', '03710'], code: '224' },
  { postalCodes: ['02700'], code: '235' },
  { postalCodes: ['04200', '04220', '04230', '04250', '04260'], code: '245' },
  {
    postalCodes: [
      '02390',
      '02400',
      '02410',
      '02420',
      '02430',
      '02440',
      '02450',
      '02460',
      '02470',
      '02480',
      '02510',
      '02520',
      '02540',
      '02550',
      '02880'
    ],
    code: '257'
  },
  {
    postalCodes: [
      '07800',
      '07810',
      '07820',
      '07830',
      '07840',
      '07850',
      '47350'
    ],
    code: '407'
  },
  {
    postalCodes: [
      '07700',
      '07720',
      '07740',
      '07750',
      '07780',
      '07870',
      '07880',
      '07890',
      '07900',
      '07910',
      '07920',
      '07930',
      '07940',
      '07945',
      '07955',
      '07960',
      '07970',
      '07980',
      '07990'
    ],
    code: '434'
  },
  {
    postalCodes: [
      '03810',
      '03850',
      '03870',
      '08100',
      '08150',
      '08200',
      '08350',
      '08360',
      '08450',
      '08480',
      '08500',
      '08680',
      '08700',
      '08800',
      '09120',
      '09220',
      '09430',
      '09520',
      '09630',
      '09810',
      '09930'
    ],
    code: '444'
  },
  { postalCodes: ['07600', '07690'], code: '504' },
  {
    postalCodes: [
      '04530',
      '04600',
      '04620',
      '04630',
      '04660',
      '04680',
      '04740',
      '04770',
      '04820',
      '04840',
      '04920',
      '04940'
    ],
    code: '505'
  },
  {
    postalCodes: [
      '01800',
      '01810',
      '01820',
      '01830',
      '01840',
      '01860',
      '01900',
      '01940',
      '05100',
      '05200',
      '05250',
      '05450'
    ],
    code: '543'
  },
  { postalCodes: ['07150', '07170', '07190'], code: '611' },
  { postalCodes: ['07550', '07560', '07565'], code: '616' },
  {
    postalCodes: [
      '06100',
      '06150',
      '06200',
      '06400',
      '06450',
      '06500',
      '06530',
      '06650',
      '06750',
      '06830',
      '06850',
      '06950',
      '07110',
      '07130',
      '07220',
      '07280',
      '07310',
      '07320',
      '07350',
      '07360',
      '07370',
      '07390',
      '07410',
      '07450'
    ],
    code: '638'
  },
  {
    postalCodes: [
      '10300',
      '10320',
      '10330',
      '10350',
      '10360',
      '10380',
      '10410',
      '10420',
      '10440',
      '10470',
      '10480',
      '10520',
      '10570',
      '10600',
      '10620',
      '10640',
      '10650',
      '10660',
      '10680',
      '10710'
    ],
    code: '710'
  },
  {
    postalCodes: [
      '01120',
      '01150',
      '01180',
      '01190',
      '04130',
      '04150',
      '04170',
      '04240',
      '06880'
    ],
    code: '753'
  },
  { postalCodes: ['02490', '02570', '02580', '02590'], code: '755' },
  {
    postalCodes: [
      '04300',
      '04310',
      '04320',
      '04330',
      '04340',
      '04350',
      '04360',
      '04370',
      '04380',
      '04390',
      '04500',
      '05400',
      '05430'
    ],
    code: '858'
  },
  {
    postalCodes: [
      '03100',
      '03150',
      '03220',
      '03250',
      '03300',
      '03320',
      '03400',
      '03430',
      '03790'
    ],
    code: '927'
  },
  { postalCodes: ['21370', '21380'], code: '019' },
  { postalCodes: ['20660', '20760', '20780', '21500', '21620'], code: '202' },
  { postalCodes: ['31500'], code: '284' },
  { postalCodes: ['23360'], code: '304' },
  {
    postalCodes: [
      '25650',
      '25700',
      '25710',
      '25730',
      '25760',
      '25810',
      '25820',
      '25830',
      '25840',
      '25860',
      '25870',
      '25900',
      '25910',
      '25930',
      '25940',
      '25950',
      '25960'
    ],
    code: '322'
  },
  { postalCodes: ['23800', '23840', '23880'], code: '400' },
  {
    postalCodes: ['21350', '21360', '21410', '21420', '21430', '21450'],
    code: '423'
  },
  {
    postalCodes: [
      '31960',
      '32200',
      '32210',
      '32250',
      '32260',
      '32270',
      '32280',
      '32300',
      '32410',
      '32430',
      '32440',
      '32450',
      '32560'
    ],
    code: '430'
  },
  {
    postalCodes: [
      '21600',
      '21610',
      '21630',
      '21650',
      '21660',
      '21670',
      '21680',
      '21710',
      '21720',
      '21740',
      '21750',
      '21760',
      '21770',
      '23390'
    ],
    code: '445'
  },
  { postalCodes: ['21480', '21490', '21560'], code: '480' },
  { postalCodes: ['21230', '21240', '21250'], code: '481' },
  { postalCodes: ['23100', '23120', '23140'], code: '503' },
  {
    postalCodes: [
      '21100',
      '21110',
      '21130',
      '21140',
      '21150',
      '21160',
      '21180',
      '21195'
    ],
    code: '529'
  },
  { postalCodes: ['21270'], code: '538' },
  { postalCodes: ['32500', '32520'], code: '561' },
  { postalCodes: ['21510', '21520', '21530', '21540', '21555'], code: '577' },
  { postalCodes: ['23950', '23960', '27320', '27340'], code: '631' },
  {
    postalCodes: [
      '21800',
      '21820',
      '21840',
      '21860',
      '21870',
      '21880',
      '21890',
      '21900',
      '21930'
    ],
    code: '636'
  },
  {
    postalCodes: ['21120', '21200', '21210', '21220', '21260', '21280'],
    code: '680'
  },
  { postalCodes: ['21290', '21310'], code: '704' },
  {
    postalCodes: [
      '24100',
      '24130',
      '24240',
      '24260',
      '24280',
      '24800',
      '24910',
      '25110',
      '25130',
      '25160',
      '25170',
      '25180',
      '25190',
      '25210',
      '25230',
      '25240',
      '25250',
      '25260',
      '25320',
      '25330',
      '25340',
      '25360',
      '25370',
      '25380',
      '25390',
      '25410',
      '25420',
      '25430',
      '25460',
      '25470',
      '25500',
      '25520',
      '25540',
      '25550',
      '25560',
      '25570',
      '25610',
      '25630',
      '25640',
      '25660'
    ],
    code: '734'
  },
  { postalCodes: ['21570', '21590'], code: '738' },
  {
    postalCodes: [
      '31400',
      '31410',
      '31450',
      '31460',
      '31470',
      '31490',
      '31520',
      '31530'
    ],
    code: '761'
  },
  { postalCodes: ['23310'], code: '833' },
  {
    postalCodes: [
      '20100',
      '20200',
      '20210',
      '20240',
      '20250',
      '20300',
      '20320',
      '20360',
      '20380',
      '20400',
      '20460',
      '20500',
      '20520',
      '20540',
      '20610',
      '20700',
      '20720',
      '20730',
      '20740',
      '20750',
      '20800',
      '20810',
      '20880',
      '20900',
      '20960',
      '21330',
      '21340'
    ],
    code: '853'
  },
  { postalCodes: ['23450', '23500', '23600', '23660', '23930'], code: '895' },
  { postalCodes: ['23200', '23210', '23260'], code: '918' },
  {
    postalCodes: [
      '27400',
      '27420',
      '27430',
      '27450',
      '27500',
      '27510',
      '27600',
      '27640',
      '27650',
      '27670'
    ],
    code: '050'
  },
  {
    postalCodes: [
      '27100',
      '27110',
      '27130',
      '27150',
      '27160',
      '27170',
      '29100',
      '29180'
    ],
    code: '051'
  },
  { postalCodes: ['29200'], code: '079' },
  {
    postalCodes: ['32610', '32620', '32700', '32710', '32760', '32770'],
    code: '102'
  },
  { postalCodes: ['38800', '38860'], code: '181' },
  {
    postalCodes: [
      '38700',
      '38710',
      '38720',
      '38740',
      '38750',
      '38760',
      '38770',
      '38840',
      '38910',
      '38920',
      '38950',
      '38970'
    ],
    code: '214'
  },
  {
    postalCodes: [
      '39920',
      '39930',
      '39940',
      '39960',
      '39965',
      '39980',
      '39990'
    ],
    code: '230'
  },
  {
    postalCodes: ['32800', '32810', '32830', '32860', '32910', '32920'],
    code: '271'
  },
  {
    postalCodes: ['29740', '29750', '29760', '29790', '29900', '29940'],
    code: '484'
  },
  { postalCodes: ['29250', '29270', '29280'], code: '531' },
  { postalCodes: ['29630', '29640', '38680'], code: '608' },
  {
    postalCodes: [
      '28100',
      '28120',
      '28130',
      '28190',
      '28200',
      '28220',
      '28240',
      '28300',
      '28330',
      '28360',
      '28370',
      '28430',
      '28500',
      '28540',
      '28560',
      '28580',
      '28600',
      '28610',
      '28660',
      '28760',
      '28800',
      '28840',
      '28880',
      '28900',
      '29570',
      '29600',
      '29680',
      '29700',
      '29720',
      '38600',
      '38650',
      '38670'
    ],
    code: '609'
  },
  {
    postalCodes: [
      '26100',
      '26200',
      '26410',
      '26510',
      '26560',
      '26660',
      '26720',
      '26740',
      '26820',
      '26840',
      '26910',
      '26930',
      '26950',
      '27220',
      '27230',
      '27250',
      '27260',
      '27310'
    ],
    code: '684'
  },
  { postalCodes: ['29810', '29830', '29860', '29880'], code: '747' },
  {
    postalCodes: [
      '27710',
      '27730',
      '27740',
      '27750',
      '27800',
      '27820',
      '27840',
      '27860',
      '27910',
      '27920'
    ],
    code: '783'
  },
  {
    postalCodes: [
      '28260',
      '28400',
      '28450',
      '29310',
      '29320',
      '29340',
      '29350'
    ],
    code: '886'
  },
  {
    postalCodes: ['30100', '30300', '30420', '31110', '31130', '31170'],
    code: '061'
  },
  {
    postalCodes: [
      '13700',
      '13720',
      '13800',
      '13880',
      '13900',
      '14430',
      '14530',
      '14610',
      '14620'
    ],
    code: '082'
  },
  {
    postalCodes: [
      '12100',
      '12130',
      '12170',
      '12210',
      '12240',
      '12310',
      '12350'
    ],
    code: '086'
  },
  { postalCodes: ['31640', '31650'], code: '103' },
  {
    postalCodes: [
      '13100',
      '13110',
      '13130',
      '13200',
      '13210',
      '13220',
      '13250',
      '13270',
      '13300',
      '13430',
      '13500',
      '13530',
      '13600',
      '14300',
      '14450',
      '14500',
      '14680',
      '14690',
      '14700',
      '14770',
      '14810',
      '14820',
      '14840',
      '14870',
      '14930',
      '16900',
      '16960',
      '16970'
    ],
    code: '109'
  },
  {
    postalCodes: [
      '12380',
      '12400',
      '12450',
      '13330',
      '14140',
      '14200',
      '14240'
    ],
    code: '165'
  },
  { postalCodes: ['31600', '31610', '31620', '31630'], code: '169' },
  {
    postalCodes: [
      '12520',
      '12540',
      '12600',
      '12630',
      '12640',
      '12700',
      '12750',
      '12820',
      '12920',
      '12950'
    ],
    code: '433'
  },
  {
    postalCodes: ['11100', '11120', '11130', '11310', '11710', '11910'],
    code: '694'
  },
  {
    postalCodes: [
      '31230',
      '31250',
      '31300',
      '31310',
      '31340',
      '31350',
      '31370',
      '31380'
    ],
    code: '834'
  },
  { postalCodes: ['32100', '32140'], code: '981' },
  { postalCodes: ['37800', '37830', '37900', '37910', '37960'], code: '020' },
  {
    postalCodes: [
      '38490',
      '39100',
      '39110',
      '39130',
      '39150',
      '39170',
      '39180',
      '39195',
      '39200',
      '39230',
      '39290',
      '39380'
    ],
    code: '108'
  },
  {
    postalCodes: [
      '39410',
      '39430',
      '39450',
      '39500',
      '39530',
      '39580',
      '39590',
      '39610'
    ],
    code: '143'
  },
  { postalCodes: ['35500', '35520', '35530', '35540', '35550'], code: '177' },
  {
    postalCodes: [
      '36100',
      '36110',
      '36120',
      '36200',
      '36220',
      '36240',
      '36270',
      '36280',
      '36340',
      '36420',
      '36430',
      '36520',
      '36570',
      '36810',
      '36840',
      '36880'
    ],
    code: '211'
  },
  { postalCodes: ['39810', '39820', '39880'], code: '250' },
  {
    postalCodes: [
      '17780',
      '17800',
      '17840',
      '17850',
      '17870',
      '17930',
      '17950',
      '17970'
    ],
    code: '291'
  },
  {
    postalCodes: ['33880', '37500', '37530', '37550', '37560', '37570'],
    code: '418'
  },
  {
    postalCodes: [
      '35700',
      '35800',
      '35820',
      '35990',
      '42830',
      '42840',
      '42850'
    ],
    code: '508'
  },
  {
    postalCodes: [
      '33380',
      '37100',
      '37120',
      '37130',
      '37140',
      '37150',
      '37180',
      '37200',
      '37210',
      '37240',
      '37310'
    ],
    code: '536'
  },
  {
    postalCodes: [
      '35100',
      '35220',
      '35240',
      '35260',
      '35270',
      '35300',
      '35320',
      '35420',
      '35480'
    ],
    code: '562'
  },
  {
    postalCodes: ['39620', '39660', '39700', '39750', '39770', '39780'],
    code: '581'
  },
  { postalCodes: ['33920', '33950', '33960', '33980'], code: '604' },
  {
    postalCodes: ['31810', '31850', '31900', '31930', '31950', '31970'],
    code: '619'
  },
  {
    postalCodes: [
      '14960',
      '14980',
      '36450',
      '36600',
      '36640',
      '36660',
      '36720',
      '36760',
      '36910',
      '36930'
    ],
    code: '635'
  },
  {
    postalCodes: [
      '34410',
      '34420',
      '34430',
      '34450',
      '34600',
      '34640',
      '34870',
      '35740',
      '35750'
    ],
    code: '702'
  },
  {
    postalCodes: [
      '32730',
      '32740',
      '38100',
      '38120',
      '38130',
      '38140',
      '38200',
      '38210',
      '38220',
      '38250',
      '38270',
      '38280',
      '38300',
      '38360',
      '38420',
      '38460',
      '38470',
      '38510'
    ],
    code: '790'
  },
  {
    postalCodes: [
      '33100',
      '33180',
      '33200',
      '33210',
      '33230',
      '33240',
      '33250',
      '33270',
      '33300',
      '33310',
      '33330',
      '33340',
      '33400',
      '33410',
      '33420',
      '33500',
      '33520',
      '33530',
      '33540',
      '33560',
      '33580',
      '33610',
      '33680',
      '33700',
      '33710',
      '33720',
      '33730',
      '33800',
      '33820',
      '33840',
      '33850',
      '33870',
      '33900',
      '34240',
      '34260',
      '34270'
    ],
    code: '837'
  },
  {
    postalCodes: [
      '31140',
      '31160',
      '31700',
      '31720',
      '31730',
      '31750',
      '31760',
      '31830',
      '31860'
    ],
    code: '887'
  },
  {
    postalCodes: [
      '37600',
      '37630',
      '37700',
      '37720',
      '37740',
      '37770',
      '37850',
      '37860'
    ],
    code: '908'
  },
  { postalCodes: ['37350', '37370', '37380', '37420', '37470'], code: '922' },
  {
    postalCodes: [
      '34710',
      '34730',
      '34740',
      '34770',
      '34800',
      '34910',
      '34930',
      '34950',
      '34970',
      '34980',
      '42870'
    ],
    code: '936'
  },
  {
    postalCodes: [
      '33430',
      '33450',
      '33470',
      '33480',
      '34110',
      '34130',
      '34140',
      '34150',
      '34180',
      '34300',
      '34320',
      '34330',
      '34510',
      '34530',
      '34550',
      '39160',
      '39310',
      '39340',
      '39360'
    ],
    code: '980'
  },
  {
    postalCodes: [
      '17130',
      '17150',
      '17200',
      '17220',
      '17240',
      '17320',
      '17410',
      '17430',
      '17440',
      '17450'
    ],
    code: '016'
  },
  {
    postalCodes: [
      '19510',
      '19540',
      '19600',
      '19610',
      '19620',
      '19630',
      '19850'
    ],
    code: '081'
  },
  {
    postalCodes: [
      '15270',
      '15820',
      '15860',
      '15870',
      '15880',
      '15980',
      '16500',
      '16630',
      '16710',
      '16730',
      '16790',
      '16800',
      '17110',
      '17120'
    ],
    code: '098'
  },
  {
    postalCodes: [
      '18100',
      '18120',
      '18130',
      '18150',
      '18200',
      '18300',
      '18600',
      '19110',
      '19120',
      '19210',
      '19250',
      '19260',
      '52980'
    ],
    code: '111'
  },
  {
    postalCodes: [
      '19160',
      '47310',
      '47400',
      '47440',
      '47450',
      '47460',
      '47490',
      '47520',
      '47540',
      '47610'
    ],
    code: '142'
  },
  { postalCodes: ['16540', '16600', '16610', '16670'], code: '316' },
  {
    postalCodes: [
      '15100',
      '15110',
      '15140',
      '15150',
      '15160',
      '15170',
      '15200',
      '15210',
      '15230',
      '15240',
      '15300',
      '15320',
      '15340',
      '15460',
      '15500',
      '15520',
      '15540',
      '15550',
      '15560',
      '15580',
      '15610',
      '15680',
      '15700',
      '15800',
      '15810',
      '15830',
      '15840',
      '15850',
      '15900',
      '15950',
      '16100',
      '16160'
    ],
    code: '398'
  },
  {
    postalCodes: [
      '16200',
      '16230',
      '16260',
      '16270',
      '16280',
      '16300',
      '16310',
      '16320',
      '16330',
      '16350',
      '16390',
      '16450',
      '16510'
    ],
    code: '560'
  },
  {
    postalCodes: [
      '17470',
      '17500',
      '17510',
      '17530',
      '17610',
      '17630',
      '17710',
      '17740'
    ],
    code: '576'
  },
  {
    postalCodes: [
      '19230',
      '19310',
      '19320',
      '19370',
      '19700',
      '19730',
      '19740',
      '19770'
    ],
    code: '781'
  },
  {
    postalCodes: [
      '49400',
      '49410',
      '49420',
      '49460',
      '49480',
      '49490',
      '49510',
      '49520',
      '49540',
      '49570',
      '49610',
      '49630',
      '49640',
      '49660',
      '49780',
      '49840'
    ],
    code: '075'
  },
  {
    postalCodes: [
      '46930',
      '48100',
      '48130',
      '48200',
      '48210',
      '48220',
      '48230',
      '48300',
      '48310',
      '48350',
      '48400',
      '48410',
      '48600',
      '48700',
      '48710',
      '48720',
      '48750',
      '48770',
      '48800',
      '48810',
      '48900',
      '48910',
      '48930',
      '49300',
      '49340'
    ],
    code: '285'
  },
  {
    postalCodes: [
      '45100',
      '45120',
      '45130',
      '45150',
      '45160',
      '45200',
      '45330',
      '45360',
      '45370',
      '45410',
      '45460',
      '45610',
      '45700',
      '45720',
      '45740',
      '45750',
      '45810',
      '45910',
      '45940',
      '46110',
      '46140',
      '46230',
      '46400',
      '46430',
      '46450',
      '46570',
      '46710',
      '46730',
      '46750',
      '46800',
      '46810',
      '46860',
      '46900',
      '46910',
      '46950',
      '46960',
      '47110',
      '47150',
      '47200',
      '47260',
      '47650',
      '47710',
      '47760',
      '47810',
      '47830',
      '47850',
      '47900',
      '47910',
      '52920'
    ],
    code: '286'
  },
  {
    postalCodes: [
      '49700',
      '49720',
      '49730',
      '49750',
      '49760',
      '49770',
      '54490'
    ],
    code: '489'
  },
  {
    postalCodes: ['49200', '49210', '49220', '49240', '49270', '49290'],
    code: '624'
  },
  { postalCodes: ['49860', '49900', '49930', '49960', '49980'], code: '935' },
  {
    postalCodes: [
      '55100',
      '55120',
      '55400',
      '55420',
      '55510',
      '55610',
      '55700',
      '55800',
      '55910'
    ],
    code: '153'
  },
  {
    postalCodes: [
      '53100',
      '53130',
      '53200',
      '53300',
      '53400',
      '53420',
      '53500',
      '53550',
      '53600',
      '53650',
      '53810',
      '53830',
      '53850',
      '53900',
      '53920',
      '53950',
      '54100',
      '54110',
      '54120',
      '54190',
      '54230',
      '54250',
      '54260',
      '54270',
      '54300',
      '54310',
      '54330',
      '54390',
      '54410',
      '54430',
      '54460',
      '55300',
      '55320',
      '55330'
    ],
    code: '405'
  },
  { postalCodes: ['54710', '54720', '54820', '54850'], code: '416' },
  {
    postalCodes: [
      '46530',
      '54500',
      '54510',
      '54530',
      '54550',
      '54580',
      '54590'
    ],
    code: '441'
  },
  {
    postalCodes: [
      '59100',
      '59130',
      '59210',
      '59310',
      '59320',
      '59410',
      '59510',
      '59520',
      '59530',
      '59610',
      '59710',
      '59720',
      '59730'
    ],
    code: '580'
  },
  {
    postalCodes: ['56550', '56610', '56640', '56710', '56730', '56800'],
    code: '689'
  },
  {
    postalCodes: [
      '56100',
      '56120',
      '56140',
      '56210',
      '56310',
      '56330',
      '56410',
      '56440',
      '56510'
    ],
    code: '700'
  },
  { postalCodes: ['54750', '54770', '54800', '54950'], code: '739' },
  {
    postalCodes: ['54915', '54920', '54930', '54940', '54960', '56350'],
    code: '831'
  },
  { postalCodes: ['58160', '58170', '58175', '58180'], code: '046' },
  { postalCodes: ['52510', '52520', '52550', '52610', '52620'], code: '097' },
  {
    postalCodes: [
      '51760',
      '51780',
      '51810',
      '51820',
      '51850',
      '51860',
      '51880',
      '51890',
      '51900',
      '51930',
      '51940',
      '51980'
    ],
    code: '178'
  },
  {
    postalCodes: [
      '51200',
      '51260',
      '51270',
      '51310',
      '51335',
      '51340',
      '51360',
      '51380',
      '51430',
      '51440',
      '51460'
    ],
    code: '213'
  },
  {
    postalCodes: [
      '50100',
      '50120',
      '50130',
      '50150',
      '50160',
      '50170',
      '50180',
      '50190',
      '50200',
      '50300',
      '50350',
      '50500',
      '50520',
      '50600',
      '50670',
      '50700',
      '50770',
      '50800',
      '50970',
      '51130',
      '51420',
      '51450',
      '51520',
      '51540',
      '51600',
      '51620',
      '51670',
      '51720',
      '51740',
      '52100',
      '52110',
      '52150',
      '52300',
      '52320',
      '52330',
      '52340',
      '52360',
      '52420',
      '52780',
      '52830',
      '77380'
    ],
    code: '491'
  },
  {
    postalCodes: [
      '19410',
      '19420',
      '19430',
      '19460',
      '19470',
      '19480',
      '52700',
      '52720',
      '52730',
      '52740',
      '52760',
      '52850',
      '52890',
      '52960',
      '52970'
    ],
    code: '507'
  },
  {
    postalCodes: [
      '76100',
      '76120',
      '76130',
      '76150',
      '76280',
      '76620',
      '76780',
      '76850',
      '76940',
      '77110',
      '77120',
      '77140',
      '77220',
      '77240',
      '77320',
      '77330',
      '77350',
      '77430',
      '77520',
      '77570',
      '77580'
    ],
    code: '593'
  },
  { postalCodes: ['52200', '52230', '52270'], code: '623' },
  {
    postalCodes: ['58830', '58850', '58900', '58910', '58920', '58940'],
    code: '681'
  },
  {
    postalCodes: [
      '57100',
      '57120',
      '57130',
      '57170',
      '57200',
      '57210',
      '57220',
      '57230',
      '57310',
      '57510',
      '57600',
      '57710',
      '57810',
      '58130',
      '58140',
      '58150',
      '58200',
      '58220',
      '58260',
      '58300',
      '58320',
      '58360',
      '58390',
      '58410',
      '58420',
      '58430',
      '58450',
      '58500',
      '58520',
      '58550',
      '58570',
      '58580',
      '58650',
      '58680',
      '58690',
      '58770',
      '58810'
    ],
    code: '740'
  },
  { postalCodes: ['58610', '58620', '58700', '58720'], code: '768' },
  {
    postalCodes: [
      '74100',
      '74120',
      '74130',
      '74140',
      '74150',
      '74160',
      '74170',
      '74510',
      '74520',
      '74540',
      '74550',
      '74595'
    ],
    code: '140'
  },
  {
    postalCodes: [
      '77460',
      '77480',
      '78880',
      '79600',
      '79620',
      '79630',
      '79660',
      '79680',
      '79690'
    ],
    code: '171'
  },
  { postalCodes: ['73600', '73620', '73640', '73645', '73670'], code: '204' },
  { postalCodes: ['72600', '72630', '72930', '72950', '72980'], code: '239' },
  {
    postalCodes: [
      '74610',
      '74630',
      '74640',
      '74670',
      '74680',
      '74700',
      '74720',
      '74740',
      '74770',
      '74840',
      '74940',
      '74980'
    ],
    code: '263'
  },
  {
    postalCodes: [
      '70100',
      '70110',
      '70150',
      '70200',
      '70210',
      '70240',
      '70260',
      '70280',
      '70300',
      '70340',
      '70400',
      '70420',
      '70460',
      '70500',
      '70600',
      '70620',
      '70700',
      '70780',
      '70800',
      '70820',
      '70840',
      '70870',
      '70940',
      '71130',
      '71150',
      '71160',
      '71310',
      '71330',
      '71360',
      '71380',
      '71480',
      '71490',
      '71520',
      '71570',
      '71610',
      '71650',
      '71660',
      '71670',
      '71680',
      '71690',
      '71720',
      '71730',
      '71740',
      '71745',
      '71750',
      '71760',
      '71775',
      '71950',
      '72100',
      '72140',
      '72490',
      '73300',
      '73310',
      '73320',
      '73350',
      '73360',
      '73410',
      '73460',
      '73470',
      '73500',
      '73710',
      '73730',
      '73770',
      '73810',
      '73830'
    ],
    code: '297'
  },
  {
    postalCodes: [
      '71910',
      '71920',
      '71960',
      '73100',
      '73110',
      '73120',
      '73200',
      '73230',
      '73250',
      '74470'
    ],
    code: '402'
  },
  {
    postalCodes: [
      '71460',
      '71470',
      '78480',
      '79100',
      '79130',
      '79140',
      '79150',
      '79160',
      '79180',
      '79190',
      '79230',
      '79255',
      '79265',
      '79330',
      '79350',
      '79410'
    ],
    code: '420'
  },
  {
    postalCodes: [
      '72400',
      '72430',
      '72510',
      '72530',
      '72550',
      '72570',
      '72710',
      '72740',
      '72810',
      '72840'
    ],
    code: '595'
  },
  { postalCodes: ['77700', '77770', '77910', '77930', '77960'], code: '686' },
  { postalCodes: ['73850', '73900', '73970', '73990', '75680'], code: '687' },
  {
    postalCodes: [
      '70900',
      '70910',
      '71800',
      '71820',
      '71840',
      '71850',
      '71870',
      '71890'
    ],
    code: '749'
  },
  {
    postalCodes: [
      '74300',
      '74340',
      '74345',
      '74360',
      '74380',
      '74420',
      '74490'
    ],
    code: '762'
  },
  { postalCodes: ['77600', '77630', '77690', '77800'], code: '778' },
  { postalCodes: ['71640', '72210', '72220'], code: '844' },
  {
    postalCodes: ['71170', '71200', '71210', '71240', '71260', '71280'],
    code: '857'
  },
  {
    postalCodes: [
      '78200',
      '78210',
      '78250',
      '78300',
      '78310',
      '78400',
      '78500',
      '78610',
      '78710',
      '78850',
      '78870',
      '78900',
      '79480',
      '79520'
    ],
    code: '915'
  },
  {
    postalCodes: ['72300', '72310', '72330', '72350', '72360', '72380'],
    code: '921'
  },
  {
    postalCodes: ['74200', '74230', '74240', '74250', '74270', '74590'],
    code: '925'
  },
  {
    postalCodes: [
      '79700',
      '79810',
      '79820',
      '79830',
      '79850',
      '79860',
      '79885',
      '79895',
      '79910',
      '79940'
    ],
    code: '090'
  },
  {
    postalCodes: [
      '81350',
      '81420',
      '81430',
      '81450',
      '81460',
      '81470',
      '82820',
      '82830',
      '82900',
      '82915',
      '82960',
      '82967',
      '82980'
    ],
    code: '146'
  },
  {
    postalCodes: [
      '80100',
      '80110',
      '80130',
      '80140',
      '80160',
      '80170',
      '80200',
      '80210',
      '80220',
      '80230',
      '80260',
      '80330',
      '81200',
      '81210',
      '81260',
      '81270',
      '81280',
      '81290',
      '81295',
      '81320',
      '81330',
      '81360',
      '81390',
      '82110',
      '82120',
      '82140',
      '82160',
      '82170',
      '82180',
      '82200',
      '82210',
      '82220',
      '82710',
      '82730',
      '82750',
      '82760',
      '82815',
      '82840',
      '82850',
      '82865',
      '82870',
      '82880'
    ],
    code: '167'
  },
  {
    postalCodes: [
      '83870',
      '83880',
      '83900',
      '83910',
      '83915',
      '83940',
      '83950',
      '83985'
    ],
    code: '176'
  },
  {
    postalCodes: [
      '58350',
      '59800',
      '59810',
      '59820',
      '82380',
      '82395',
      '82430',
      '82460',
      '82490',
      '82500',
      '82510',
      '82580',
      '82590'
    ],
    code: '260'
  },
  {
    postalCodes: [
      '80510',
      '80710',
      '80770',
      '80780',
      '80790',
      '80850',
      '80910',
      '81100',
      '81120',
      '81160',
      '81220',
      '81230',
      '81235'
    ],
    code: '276'
  },
  { postalCodes: ['83500', '83550', '83630', '83660'], code: '309' },
  {
    postalCodes: [
      '81560',
      '81570',
      '81590',
      '81650',
      '81660',
      '81700',
      '81720',
      '81750',
      '81810',
      '81820',
      '81850',
      '81860',
      '81950',
      '81970',
      '83960'
    ],
    code: '422'
  },
  {
    postalCodes: [
      '80400',
      '83100',
      '83130',
      '83140',
      '83150',
      '83160',
      '83320',
      '83330',
      '83340',
      '83400',
      '83430',
      '83450',
      '83460',
      '83480'
    ],
    code: '426'
  },
  {
    postalCodes: [
      '75500',
      '75530',
      '75650',
      '75700',
      '75710',
      '75740',
      '75770',
      '75790',
      '75840',
      '75890',
      '75930',
      '75940',
      '75970',
      '75990'
    ],
    code: '541'
  },
  {
    postalCodes: [
      '83700',
      '83720',
      '83750',
      '83760',
      '83780',
      '83825',
      '83830',
      '83835',
      '83840',
      '83855'
    ],
    code: '607'
  },
  { postalCodes: ['82290', '82300', '82310', '82335'], code: '707' },
  {
    postalCodes: [
      '82350',
      '82360',
      '82600',
      '82655',
      '82660',
      '82670',
      '82675',
      '82685',
      '82770'
    ],
    code: '848'
  },
  {
    postalCodes: [
      '41490',
      '41500',
      '41520',
      '41530',
      '41540',
      '41550',
      '41560',
      '41580'
    ],
    code: '077'
  },
  {
    postalCodes: ['19650', '19670', '19920', '41730', '41750', '41770'],
    code: '172'
  },
  {
    postalCodes: [
      '40100',
      '40200',
      '40250',
      '40270',
      '40320',
      '40340',
      '40400',
      '40420',
      '40500',
      '40520',
      '40530',
      '40600',
      '40620',
      '40630',
      '40640',
      '40660',
      '40700',
      '40720',
      '40740',
      '40800',
      '40820',
      '40900',
      '41120',
      '41140',
      '41160',
      '41450',
      '41630',
      '41710',
      '41800',
      '41820',
      '41840',
      '41860',
      '41870',
      '41880',
      '41930',
      '41940'
    ],
    code: '179'
  },
  {
    postalCodes: [
      '35400',
      '35600',
      '35610',
      '35630',
      '42100',
      '42140',
      '42220',
      '42300',
      '42330',
      '42440'
    ],
    code: '182'
  },
  { postalCodes: ['43300', '43340'], code: '216' },
  {
    postalCodes: [
      '43490',
      '43500',
      '43520',
      '43540',
      '43560',
      '43610',
      '43640',
      '43660'
    ],
    code: '226'
  },
  {
    postalCodes: [
      '41970',
      '42520',
      '42560',
      '42700',
      '42720',
      '42800',
      '42820',
      '42910',
      '42930'
    ],
    code: '249'
  },
  { postalCodes: ['43900', '43940', '43960'], code: '256' },
  { postalCodes: ['43390', '43800', '43840'], code: '265' },
  { postalCodes: ['44300', '44320', '44330', '44350', '44370'], code: '275' },
  { postalCodes: ['43700', '43720'], code: '312' },
  {
    postalCodes: [
      '41180',
      '41310',
      '41325',
      '41330',
      '41340',
      '41350',
      '41360',
      '41370',
      '41390',
      '41400'
    ],
    code: '410'
  },
  { postalCodes: ['19910', '19950'], code: '435' },
  { postalCodes: ['42600', '42660', '43430'], code: '495' },
  { postalCodes: ['40930', '40950'], code: '500' },
  { postalCodes: ['41900', '41920', '41925', '41980'], code: '592' },
  {
    postalCodes: [
      '44800',
      '44860',
      '44880',
      '44910',
      '44920',
      '44950',
      '44970'
    ],
    code: '601'
  },
  {
    postalCodes: [
      '41260',
      '41270',
      '43100',
      '43130',
      '43170',
      '43220',
      '43240',
      '43250',
      '43270',
      '43420',
      '43440',
      '43480'
    ],
    code: '729'
  },
  { postalCodes: ['41410', '41440', '41660'], code: '850' },
  { postalCodes: ['41210', '41220', '41230', '41240', '41290'], code: '892' },
  {
    postalCodes: [
      '44480',
      '44500',
      '44530',
      '44580',
      '44590',
      '44610',
      '44630',
      '44640',
      '44670',
      '44680',
      '44730',
      '44740',
      '44760',
      '44770',
      '44790'
    ],
    code: '931'
  },
  {
    postalCodes: [
      '44100',
      '44120',
      '44150',
      '44160',
      '44170',
      '44190',
      '44200',
      '44220',
      '44250',
      '44260',
      '44280',
      '44400',
      '44420',
      '44440',
      '44460'
    ],
    code: '992'
  },
  {
    postalCodes: [
      '62710',
      '62720',
      '62730',
      '62740',
      '62750',
      '62760',
      '62830',
      '62900',
      '62920',
      '62940',
      '62950',
      '62990',
      '63500',
      '63510',
      '63530',
      '63540'
    ],
    code: '005'
  },
  {
    postalCodes: [
      '61150',
      '61170',
      '63210',
      '63300',
      '63320',
      '63330',
      '63340',
      '63350',
      '63355',
      '63360',
      '63370',
      '63400',
      '63410',
      '63430',
      '63600',
      '63610',
      '63640',
      '63680'
    ],
    code: '010'
  },
  { postalCodes: ['62500', '62510', '62520', '62540', '62570'], code: '052' },
  {
    postalCodes: [
      '60450',
      '60720',
      '60760',
      '60800',
      '61330',
      '61340',
      '61350'
    ],
    code: '145'
  },
  {
    postalCodes: [
      '64810',
      '64820',
      '64830',
      '64840',
      '64850',
      '64900',
      '64930'
    ],
    code: '151'
  },
  { postalCodes: ['61500', '61520', '61550', '61560', '66440'], code: '152' },
  { postalCodes: ['64350', '64370'], code: '218' },
  {
    postalCodes: [
      '61800',
      '61810',
      '61820',
      '61850',
      '61860',
      '61880',
      '61910',
      '61920',
      '61940',
      '61950',
      '61960',
      '61980'
    ],
    code: '232'
  },
  {
    postalCodes: [
      '62150',
      '62200',
      '62220',
      '62230',
      '62240',
      '62260',
      '62300',
      '62310',
      '62340',
      '62350',
      '62370',
      '62375',
      '62380',
      '62410',
      '62420',
      '62430',
      '62435',
      '62440',
      '62470'
    ],
    code: '233'
  },
  {
    postalCodes: [
      '63100',
      '63120',
      '63130',
      '63150',
      '63160',
      '63230',
      '63250',
      '63450'
    ],
    code: '300'
  },
  {
    postalCodes: [
      '61220',
      '61230',
      '61250',
      '61270',
      '61280',
      '61290',
      '61300',
      '61310',
      '61360',
      '61370',
      '61380',
      '61600',
      '61630',
      '61640',
      '61680',
      '61710',
      '61720',
      '61730',
      '61760',
      '66300',
      '66320',
      '66330',
      '66340',
      '66350',
      '66360',
      '66370'
    ],
    code: '301'
  },
  {
    postalCodes: ['62600', '62610', '62620', '62630', '62640', '62660'],
    code: '403'
  },
  {
    postalCodes: [
      '62100',
      '62130',
      '62160',
      '62165',
      '62170',
      '62175',
      '62185',
      '62190',
      '62280',
      '62290',
      '62295'
    ],
    code: '408'
  },
  {
    postalCodes: [
      '60100',
      '60120',
      '60150',
      '60200',
      '60220',
      '60280',
      '60320',
      '60420',
      '60510',
      '60550',
      '60560',
      '60640',
      '61100',
      '61110',
      '61120',
      '61140',
      '61160',
      '61180',
      '61400',
      '61410',
      '61430',
      '61440',
      '61450',
      '61460',
      '61470',
      '61650'
    ],
    code: '743'
  },
  { postalCodes: ['63800', '63830', '63880', '63890'], code: '759' },
  {
    postalCodes: ['61840', '64700', '64720', '64740', '64760', '64770'],
    code: '846'
  },
  {
    postalCodes: ['62800', '62810', '62840', '62860', '62870', '62880'],
    code: '934'
  },
  {
    postalCodes: [
      '63660',
      '63700',
      '63770',
      '63780',
      '63900',
      '63910',
      '63920',
      '63950'
    ],
    code: '989'
  },
  { postalCodes: ['64260'], code: '231' },
  { postalCodes: ['66200', '66210', '66230', '66280', '66290'], code: '280' },
  {
    postalCodes: [
      '64100',
      '64140',
      '64300',
      '64320',
      '64440',
      '64450',
      '64460',
      '64480',
      '64490'
    ],
    code: '287'
  },
  { postalCodes: ['68410', '68500', '68700', '68750'], code: '288' },
  { postalCodes: ['66400', '66420', '66450', '66460', '66470'], code: '399' },
  { postalCodes: ['68555', '68560', '68570', '68580'], code: '440' },
  {
    postalCodes: ['66100', '66140', '66160', '66220', '66240', '66260'],
    code: '475'
  },
  {
    postalCodes: [
      '65450',
      '65460',
      '65470',
      '65480',
      '65520',
      '65610',
      '65630',
      '65650',
      '65710',
      '65730',
      '65760',
      '65800',
      '65870',
      '65920',
      '65930',
      '65970',
      '66520',
      '66530',
      '66540',
      '66550',
      '66560',
      '66580',
      '66590',
      '66999'
    ],
    code: '499'
  },
  {
    postalCodes: [
      '64200',
      '64210',
      '64220',
      '64230',
      '64240',
      '64250',
      '64510',
      '64530',
      '64550',
      '64610',
      '66270',
      '66295'
    ],
    code: '545'
  },
  { postalCodes: ['68600', '68620', '68630', '68660'], code: '598' },
  {
    postalCodes: [
      '68530',
      '68690',
      '68800',
      '68810',
      '68820',
      '68830',
      '68840',
      '68870',
      '68910',
      '68920',
      '68930',
      '68940',
      '68970'
    ],
    code: '599'
  },
  {
    postalCodes: [
      '66840',
      '66850',
      '66900',
      '66910',
      '66930',
      '66950',
      '66970',
      '66980'
    ],
    code: '893'
  },
  {
    postalCodes: [
      '65100',
      '65130',
      '65170',
      '65200',
      '65230',
      '65280',
      '65300',
      '65320',
      '65350',
      '65370',
      '65380',
      '65410',
      '66430',
      '66500',
      '66510'
    ],
    code: '905'
  },
  {
    postalCodes: [
      '62395',
      '66600',
      '66640',
      '66660',
      '66680',
      '66710',
      '66730',
      '66800',
      '66810',
      '66820',
      '66830'
    ],
    code: '946'
  },
  { postalCodes: ['69510', '69550', '69570'], code: '074' },
  { postalCodes: ['69100', '69150', '69170'], code: '217' },
  { postalCodes: ['69600', '69660'], code: '236' },
  {
    postalCodes: [
      '67100',
      '67200',
      '67300',
      '67400',
      '67410',
      '67500',
      '67600',
      '67700',
      '67800',
      '67900',
      '68210',
      '68220',
      '68230',
      '68240',
      '68300',
      '68320',
      '68370',
      '68380',
      '68390',
      '68550',
      '68999'
    ],
    code: '272'
  },
  { postalCodes: ['69420', '69440', '69450'], code: '421' },
  { postalCodes: ['69910', '69920', '69950', '69970', '69980'], code: '584' },
  { postalCodes: ['69300', '69310', '69330', '69340', '69410'], code: '849' },
  {
    postalCodes: ['69700', '69730', '69750', '69820', '69830', '69850'],
    code: '924'
  },
  { postalCodes: ['85200', '85210', '85230'], code: '009' },
  { postalCodes: ['85710', '85730', '85800', '85820', '85840'], code: '069' },
  {
    postalCodes: [
      '86480',
      '86530',
      '86550',
      '86600',
      '86650',
      '86680',
      '86690'
    ],
    code: '071'
  },
  { postalCodes: ['90480'], code: '072' },
  {
    postalCodes: [
      '91100',
      '91110',
      '91140',
      '91150',
      '91210',
      '95100',
      '95110',
      '95130',
      '95160'
    ],
    code: '139'
  },
  {
    postalCodes: [
      '68100',
      '68150',
      '85100',
      '85120',
      '85140',
      '85150',
      '85160',
      '85180'
    ],
    code: '208'
  },
  { postalCodes: ['90440', '90450'], code: '244' },
  {
    postalCodes: ['93600', '93700', '93800', '93830', '93900', '93999'],
    code: '305'
  },
  { postalCodes: ['86710', '86790'], code: '317' },
  { postalCodes: ['91900', '91910', '91930'], code: '425' },
  { postalCodes: ['91980'], code: '436' },
  { postalCodes: ['86220', '86230', '86240'], code: '483' },
  { postalCodes: ['91410', '91430', '91500', '91510', '91560'], code: '494' },
  {
    postalCodes: [
      '85500',
      '85540',
      '85560',
      '85580',
      '85620',
      '85630',
      '85640',
      '85660'
    ],
    code: '535'
  },
  { postalCodes: ['86210', '86300', '86350', '86510'], code: '563' },
  {
    postalCodes: [
      '90100',
      '90120',
      '90130',
      '90140',
      '90150',
      '90220',
      '90230',
      '90240',
      '90250',
      '90310',
      '90400',
      '90410',
      '90420',
      '90460',
      '90470',
      '90500',
      '90510',
      '90520',
      '90530',
      '90540',
      '90550',
      '90560',
      '90570',
      '90580',
      '90590',
      '90600',
      '90620',
      '90630',
      '90650',
      '90660',
      '90670',
      '90800',
      '90810',
      '90820',
      '90830',
      '90840',
      '90850',
      '90860',
      '90900',
      '90910',
      '90940',
      '91200',
      '91240',
      '91260',
      '91300',
      '91310'
    ],
    code: '564'
  },
  {
    postalCodes: [
      '93100',
      '93140',
      '93160',
      '93170',
      '93180',
      '93187',
      '93190',
      '93195',
      '93220',
      '93225',
      '93240',
      '93250',
      '93270',
      '93277',
      '93280',
      '93290',
      '93350',
      '93390'
    ],
    code: '615'
  },
  { postalCodes: ['86100', '86110', '86160', '86170'], code: '625' },
  {
    postalCodes: ['86800', '86810', '86850', '86870', '86900', '86980'],
    code: '626'
  },
  { postalCodes: ['92910', '92920', '92930'], code: '630' },
  {
    postalCodes: [
      '86360',
      '86400',
      '86440',
      '86460',
      '86470',
      '92100',
      '92120',
      '92130',
      '92140',
      '92150',
      '92160',
      '92180',
      '92210',
      '92220',
      '92230',
      '92240',
      '92260'
    ],
    code: '678'
  },
  { postalCodes: ['85900', '85930', '85940', '85980'], code: '691' },
  {
    postalCodes: [
      '85310',
      '85320',
      '85340',
      '85410',
      '85430',
      '85450',
      '85470'
    ],
    code: '746'
  },
  {
    postalCodes: [
      '92320',
      '92330',
      '92350',
      '92400',
      '92430',
      '92440',
      '92450',
      '92470'
    ],
    code: '748'
  },
  {
    postalCodes: [
      '88340',
      '91700',
      '91710',
      '91720',
      '91730',
      '91740',
      '91750',
      '91760',
      '91780',
      '91790',
      '92810',
      '92830'
    ],
    code: '785'
  },
  {
    postalCodes: [
      '92500',
      '92520',
      '92530',
      '92600',
      '92610',
      '92620',
      '92640',
      '92650',
      '92700'
    ],
    code: '791'
  },
  {
    postalCodes: ['93400', '93420', '93440', '93470', '93540', '93590'],
    code: '832'
  },
  { postalCodes: ['91800', '91950'], code: '859' },
  {
    postalCodes: ['91600', '91620', '91630', '91640', '91660', '91670'],
    code: '889'
  },
  {
    postalCodes: ['84100', '84460', '84540', '84650', '84770', '84880'],
    code: '977'
  },
  { postalCodes: ['89400', '89430', '89540', '89560'], code: '105' },
  {
    postalCodes: [
      '87100',
      '87150',
      '87200',
      '87250',
      '87300',
      '87400',
      '87500',
      '87700',
      '87800',
      '87830',
      '87850',
      '87900',
      '87910',
      '87930',
      '87950',
      '87970',
      '88200',
      '88270'
    ],
    code: '205'
  },
  {
    postalCodes: [
      '88730',
      '88740',
      '88760',
      '88820',
      '88900',
      '88930',
      '88940'
    ],
    code: '290'
  },
  { postalCodes: ['88300', '88310', '88350', '88380', '88470'], code: '578' },
  {
    postalCodes: ['89110', '89140', '89200', '89210', '89320', '89330'],
    code: '620'
  },
  { postalCodes: ['88400', '88440', '88460'], code: '697' },
  {
    postalCodes: [
      '74390',
      '88120',
      '88490',
      '88530',
      '88600',
      '88610',
      '88615',
      '88620',
      '88640',
      '88670',
      '88690'
    ],
    code: '765'
  },
  {
    postalCodes: [
      '89440',
      '89600',
      '89610',
      '89640',
      '89660',
      '89670',
      '89680',
      '89730',
      '89740',
      '89760',
      '89770',
      '89780',
      '89800',
      '89830',
      '89840',
      '89920'
    ],
    code: '777'
  },
  {
    postalCodes: [
      '99400',
      '99410',
      '99420',
      '99430',
      '99440',
      '99450',
      '99460',
      '99470',
      '99490'
    ],
    code: '047'
  },
  {
    postalCodes: [
      '99800',
      '99830',
      '99860',
      '99870',
      '99885',
      '99910',
      '99930',
      '99940'
    ],
    code: '148'
  },
  {
    postalCodes: [
      '94100',
      '94200',
      '94300',
      '94600',
      '94700',
      '94720',
      '94800',
      '94830',
      '94900'
    ],
    code: '240'
  },
  {
    postalCodes: [
      '94400',
      '94450',
      '94500',
      '95310',
      '95315',
      '95365',
      '95370'
    ],
    code: '241'
  },
  {
    postalCodes: [
      '97420',
      '97470',
      '97999',
      '99100',
      '99110',
      '99120',
      '99130',
      '99135',
      '99140',
      '99150',
      '99160',
      '99170',
      '99180',
      '99190',
      '99195',
      '99230',
      '99240',
      '99250',
      '99270',
      '99280',
      '99290',
      '99340'
    ],
    code: '261'
  },
  {
    postalCodes: [
      '95800',
      '95830',
      '95840',
      '95850',
      '95860',
      '95900',
      '95920',
      '95930',
      '95970',
      '95980',
      '95990',
      '97430'
    ],
    code: '273'
  },
  {
    postalCodes: [
      '97590',
      '97645',
      '98100',
      '98120',
      '98230',
      '98310',
      '98350',
      '98360',
      '98400',
      '98420',
      '98440',
      '98450',
      '98710',
      '98720'
    ],
    code: '320'
  },
  {
    postalCodes: [
      '95940',
      '95950',
      '99300',
      '99310',
      '99320',
      '99330',
      '99360'
    ],
    code: '498'
  },
  {
    postalCodes: [
      '98500',
      '98510',
      '98530',
      '98550',
      '98560',
      '98570',
      '98580',
      '98630'
    ],
    code: '583'
  },
  {
    postalCodes: [
      '97810',
      '97815',
      '97820',
      '97840',
      '97850',
      '97870',
      '97880',
      '97890',
      '97895',
      '97900',
      '97920',
      '97925',
      '97940',
      '97950',
      '97960',
      '97965',
      '97970',
      '97980',
      '98780'
    ],
    code: '614'
  },
  {
    postalCodes: [
      '97665',
      '97700',
      '97715',
      '97720',
      '97760',
      '97765',
      '97780',
      '97785'
    ],
    code: '683'
  },
  {
    postalCodes: [
      '96100',
      '96190',
      '96200',
      '96300',
      '96320',
      '96400',
      '96440',
      '96460',
      '96500',
      '96600',
      '96700',
      '96800',
      '96900',
      '96910',
      '96930',
      '96960',
      '97110',
      '97130',
      '97140',
      '97145',
      '97160',
      '97170',
      '97220',
      '97240',
      '97280',
      '97290',
      '97310',
      '97320',
      '97340',
      '97510',
      '97520',
      '97530',
      '97540',
      '97580',
      '97610',
      '97615',
      '97620',
      '97625',
      '97630',
      '97635',
      '97650',
      '97655',
      '97670',
      '97675',
      '97680',
      '97685',
      '97690'
    ],
    code: '698'
  },
  {
    postalCodes: [
      '98600',
      '98620',
      '98660',
      '98760',
      '98770',
      '98790',
      '98900',
      '98920',
      '98930',
      '98950',
      '98960',
      '98970',
      '98980',
      '98995'
    ],
    code: '732'
  },
  {
    postalCodes: [
      '98800',
      '98810',
      '98820',
      '98830',
      '98840',
      '98850',
      '99640'
    ],
    code: '742'
  },
  {
    postalCodes: [
      '95200',
      '95210',
      '95220',
      '95225',
      '95230',
      '95255',
      '95260',
      '95270'
    ],
    code: '751'
  },
  {
    postalCodes: [
      '97370',
      '97380',
      '97390',
      '99510',
      '99520',
      '99530',
      '99540',
      '99550',
      '99555',
      '99560',
      '99600',
      '99610',
      '99620',
      '99645',
      '99650',
      '99655',
      '99660',
      '99665',
      '99670',
      '99690',
      '99695',
      '99710',
      '99720',
      '99740',
      '99750',
      '99760',
      '99770'
    ],
    code: '758'
  },
  {
    postalCodes: [
      '95300',
      '95325',
      '95330',
      '95340',
      '95350',
      '95355',
      '95375'
    ],
    code: '845'
  },
  {
    postalCodes: [
      '94430',
      '94460',
      '95400',
      '95410',
      '95420',
      '95430',
      '95440',
      '95450',
      '95460',
      '95470',
      '95490',
      '95500',
      '95520',
      '95530',
      '95540',
      '95560',
      '95590'
    ],
    code: '851'
  },
  {
    postalCodes: [
      '95640',
      '95645',
      '95700',
      '95710',
      '95720',
      '95750',
      '95760',
      '95770',
      '95780',
      '95790',
      '97330',
      '97335'
    ],
    code: '854'
  },
  { postalCodes: ['99950', '99980', '99990'], code: '890' },
  {
    postalCodes: [
      '95600',
      '95610',
      '95615',
      '95620',
      '95630',
      '95635',
      '95655',
      '95660',
      '95670',
      '95675',
      '95680',
      '95690',
      '97250'
    ],
    code: '976'
  },
  {
    postalCodes: ['22840', '22910', '22920', '22930', '22940', '22950'],
    code: '035'
  },
  { postalCodes: ['22270'], code: '043' },
  { postalCodes: ['22220', '22310', '22330', '22410'], code: '060' },
  { postalCodes: ['22710'], code: '062' },
  { postalCodes: ['22340'], code: '065' },
  { postalCodes: ['22240'], code: '076' },
  { postalCodes: ['22120', '22130', '22140', '22150'], code: '170' },
  { postalCodes: ['22810', '22820', '22830'], code: '295' },
  { postalCodes: ['22730'], code: '318' },
  { postalCodes: ['22160', '22610'], code: '417' },
  { postalCodes: ['22630'], code: '438' },
  { postalCodes: ['22100'], code: '478' },
  { postalCodes: ['22320', '22430'], code: '736' },
  { postalCodes: ['22720'], code: '766' },
  { postalCodes: ['22520', '22530'], code: '771' },
  { postalCodes: ['22550'], code: '941' }
]
